import { Collapsible } from '../interfaces';

export class RangeResultsDiscussion implements Collapsible {
  message: string;
  collapsed: boolean;
}
